import { useState } from 'react';
import { faqs } from '@/mocks/data';

const FAQSection: React.FC = () => {
  const [openIds, setOpenIds] = useState<Set<string>>(new Set());

  const toggleFaq = (id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <section id="faq" className="py-10 md:py-14 bg-background-100">
        <div className="px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              关于福利铺子，您想了解的都在这里
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq) => {
              const isOpen = openIds.has(faq.id);
              return (
                <div
                  key={faq.id}
                  className="bg-white rounded-xl border border-background-200 overflow-hidden"
                >
                  <button
                    onClick={() => toggleFaq(faq.id)}
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                  >
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base pr-4">
                      {faq.question}
                    </h3>
                    <span
                      className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                    }`}
                  >
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQSection;